import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-top">
        <div className="footer-brand">
          <Link to="/" onClick={() => window.scrollTo(0, 0)} className="footer-brand-link">
            <h3>Solace Care 360</h3>
          </Link>
          <p>Solace Care 360 partners with practices and health systems to deliver comprehensive care management that supports patients, improves clinical outcomes, and reduces clinical burden.</p>
        </div>
        <nav className="footer-nav">
          <Link to="/about">About</Link>
          <Link to="/how-care-360-works">How Care 360 Works</Link>
          <Link to="/services">Our Services</Link>
          <Link to="/contact">Contact Us</Link>
        </nav>
      </div>
      <div className="footer-divider"></div>
      <div className="footer-legal">
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/disclaimers">Disclaimers</Link>
          <Link to="/terms-of-use">Terms of Use</Link>
        </div>
        <p className="footer-copyright">&copy; 2026 Solace Care 360, LLC. All Rights Reserved. Solace Care 360 provides clinical program management, care coordination support, and remote patient monitoring services to partner clinics. Solace Care 360 does not independently diagnose, prescribe, or replace the medical judgment of licensed providers.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
